export default "__VITE_ASSET__CiTumeaD__"